import script from "./taxInfoTemp.vue?vue&type=script&setup=true&lang=js"
export * from "./taxInfoTemp.vue?vue&type=script&setup=true&lang=js"

import "./taxInfoTemp.vue?vue&type=style&index=0&id=66b3894b&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66b3894b"]])

export default __exports__